import { Box,Stack,Tab,Tabs } from "@mui/material";
import { memo,useState } from "react";
import { useTranslation } from "react-i18next";
import { TabPanelProps } from "../../types/helpers/types";
import { trackEventMatomo } from '../../helpers/matomo';
import PrintTemplateTabs from "../PrintTemplate/PrintTemplateTabs";
import ListaFormulario from "./ListaFormulario";

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      style={{ width: '100%' }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function ChecklistsTabs() {
  const { t } = useTranslation('translation');
  const [value, setValue] = useState<number>(0);
  function handleChange(_event: React.SyntheticEvent, newValue: number) {
    trackEventMatomo('gestão de formulários', 'click', 'aba', newValue === 0 ? 'formulários' : 'configuração de impressão');
    setValue(newValue);
  };

  return (
    <Stack width='100%' alignItems='flex-start' justifyContent='flex-start'>
      <Tabs
        value={value}
        onChange={handleChange}
        textColor="secondary"
        indicatorColor="secondary"
        aria-label="secondary tabs example"
      >
        <Tab label={t('checklists.checklists.title')} value={0} />
        <Tab label={t('checklists.printConfig.title')} value={1} />
      </Tabs>
      <CustomTabPanel value={value} index={0}>
        <ListaFormulario />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <PrintTemplateTabs />
      </CustomTabPanel>
    </Stack>
  );
}

export default memo(ChecklistsTabs);
